module.exports = __webpack_public_path__ + "static/media/banner2.a6dea882.png";